import { useContent } from 'pages/content/hooks/useContent'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useState } from 'react'
import { BackendUser, Content, IAssignedTo, ReportActivity, ReportedContent, ReportedContentStatus, ReportedUser, ReportedUserHeadLine } from 'common/types'
import { useUserApi } from 'hooks/use-user-api/useUserApi'
import { useThemeSwitch } from 'hooks/theme'
import { assignedTo, suspendUser } from '../fixtures'
import { useNotification } from 'hooks/use-notification/useNotification'
import { useParams } from 'react-router-dom'
import { useLocalStorage } from 'hooks/use-local-storage/useLocalStorage'
import { useAdminReportedList } from 'pages/administration/hooks/reported-list/useAdminReportedList'
import { ReportedContentState } from 'models/reported-content/reported-content.store'

export const useReportedUser = () => {
  const [reportedUsers, setReportedUsers] = useState<ReportedUser[]>()
  const [totalCount, setTotalCount] = useState(0)
  const { mode } = useThemeSwitch()
  const { getAllSearchedUsers } = useContent()
  const { fetchUser } = useUserApi()
  const listHeadline = [
    ReportedUserHeadLine.CONTENT_OWNER,
    ReportedUserHeadLine.REASON,
    ReportedUserHeadLine.TYPE,
    ReportedUserHeadLine.STATUS,
    ReportedUserHeadLine.ACTION
  ]
  const { backendUser: user } = useAuth()
  const [showFilter, setShowFilter] = useState<boolean>(false)
  const { reportId } = useParams<{ reportId: string }>()
  const { backendUser } = useAuth()
  const { notify } = useNotification()
  const { setItem } = useLocalStorage()
  const {
    reportedContentAction,
  } = useAdminReportedList()
  const { reportedContent, setReportedContent, isAssignedToMyself, isLoading, setIsLoading, numberOfDays, setNumberOfDays, setShowCloseReportModal, setShowSuspendUser, setShowBlockUser, reason, setReason, setShouldDisableAllActions, setShowReportContentActionModal} = ReportedContentState

  const fetchSearchedUsers = async (page?: number, pageSize?: number, searchCriteria?: string, status?: string) => {
    try {
      setIsLoading(true)
      const reported = await getAllSearchedUsers(user?.id, page, pageSize, searchCriteria, status)
      if (reported?.data) {
        const userReported = await Promise.all(
          reported?.data.map(async user => {
            const contentOwner = await fetchUser(user?.userId)
            return {
              ...user,
              role: contentOwner?.role
            }
          })
        )
        setTotalCount(parseInt(reported?.totalCount))
        setReportedUsers(userReported)
      }
      setIsLoading(false)
    } catch (err) {
      console.warn(err)
    }
  }





  const handleAssignToSelf = async (actionType: string ) => {
    if (isAssignedToMyself(backendUser)) {
      notify('warning', `Report already assigned to you`)
      return;
    }
    try {
      const payload: ReportActivity = {
        reportedContentId: reportedContent?.contentId,
        reportedUserId: reportedContent?.contentOwnerId,
        action: actionType,
        actionDuration: numberOfDays?.toString(),
        feedback: reason,
      }
      await reportedContentAction(backendUser?.id, payload)
      notify('success', `Report assigned to you`)
      setShowSuspendUser(false)
      setShowBlockUser(false)
      setReason('')
      setNumberOfDays(null)
      setShowReportContentActionModal(false)
      setShouldDisableAllActions(true)
      setShowCloseReportModal(false)
      setReportedContent({
        ...reportedContent,
        assignedTo: `${user.firstName} ${user.lastName}`
      })
      return 
    } catch (error) {
      notify('warning', `Report already assigned to you`)
      setReason('')
      setNumberOfDays(null)
      setShowBlockUser(false)
      setShowReportContentActionModal(false)
      setShowSuspendUser(false)
      setShowCloseReportModal(false)
      return
    }
  }


  return {
    reportedUsers,
    setReportedUsers,
    listHeadline,
    mode,
    setShowFilter,
    showFilter,
    fetchSearchedUsers,
    totalCount,
    isLoading,
    setTotalCount,
    handleAssignToSelf,
  } as const
}
